import React from 'react';
import { StatCard } from '@/components/ui';
import { Maximize2, Minimize2 } from 'lucide-react';

export const DocumentsStats = ({ counts, isExpanded, onToggle }) => (
  <div className="space-y-4 relative group/stats">
    <button
      type="button"
      onClick={onToggle}
      className="absolute -top-2 right-0 z-10 p-2 bg-white border border-slate-200 rounded-xl shadow-sm text-slate-400 hover:text-brand-blue hover:border-brand-blue/30 transition-all hover:bg-slate-50 active:scale-95"
      title={isExpanded ? 'Hide details' : 'Show details'}
    >
      {isExpanded ? <Minimize2 size={10} /> : <Maximize2 size={10} />}
    </button>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-fr">
      {/*
      <StatCard
        variant="luxury"
        title="Total Documents"
        value={counts.total}
        sub="All files in library"
        isExpanded={isExpanded}
        topColor="border-t-[#5d6b8b]"
        iconHoverColor="group-hover:text-[#ffa000]"
        illustration={
          <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h2l2-2h6l2 2h2a2 2 0 012 2v10a2 2 0 01-2 2H5z" />
          </svg>
        }
      />
      */}
      <StatCard
        variant="luxury"
        title="Excel Sheets"
        value={counts.excel}
        sub="Spreadsheets & CSV"
        isExpanded={isExpanded}
        topColor="border-t-[#5d6b8b]"
        iconHoverColor="group-hover:text-[#ffa000]"
        illustration={
          <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        }
      />
      <StatCard
        variant="luxury"
        title="Word Documents"
        value={counts.word}
        sub="Editable text files"
        isExpanded={isExpanded}
        topColor="border-t-[#5d6b8b]"
        iconHoverColor="group-hover:text-[#ffa000]"
        illustration={
          <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        }
      />
      <StatCard
        variant="luxury"
        title="PDF Files"
        value={counts.pdf}
        sub="Read-only documents"
        isExpanded={isExpanded}
        topColor="border-t-[#5d6b8b]"
        iconHoverColor="group-hover:text-[#ffa000]"
        illustration={
          <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
          </svg>
        }
      />
      <StatCard
        variant="luxury"
        title="Drawings"
        value={counts.drawings}
        sub="CAD & Image files"
        isExpanded={isExpanded}
        topColor="border-t-[#5d6b8b]"
        iconHoverColor="group-hover:text-[#ffa000]"
        illustration={
          <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
        }
      />
    </div>
  </div>
);
